export default "__VITE_ASSET__DuF2Aw$r__"